const themeLightContrastHigh = '#535457';

export { themeLightContrastHigh };
